import React, { useEffect, useState } from "react";
import Breadcrumbs from "../components/Common/Breadcrumb";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Badge,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomTable from "../customComponents/reactTable/CustomTable";
import { Link } from "react-router-dom";
import {
  getIndividualInterviews,
  getIndividualJobRoles,
  getIndividualLocations,
  getJobsCount,
} from "./individualSlice";
import dayjs from "dayjs";
import CanvasInterview from "../customComponents/offcanvas/CanvasInterviewDetails";
import JobOverview from "../customComponents/offcanvas/JobOverviewCanvas";
import { JobDetail } from "../Client/ClientSlice";
import StatusBadge from "../customComponents/utilities/StatusBadge";
import moment from "moment";

function IndividualInterviews() {
  const individualStore = useSelector((state) => state.individualSlice);
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedInterview, setSelectedInterview] = useState([]);
  const dispatch = useDispatch();
  const [InterviewData, setInterviewData] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [JobRoleOptions, setJobRoleOptions] = useState([]);
  const [isJobCanvasOpen, setJobCanvasOpen] = useState(false);
  const [RecordCount, setRecordCount] = useState(0);
  const defaultStartDate = new Date();

  const defaultEndDate = new Date();
  const [formattedStartDate, setformattedStartDate] = useState(
    moment(defaultStartDate.setDate(defaultStartDate.getDate() - 90)).format(
      "YYYY-MM-DD",
    ),
  );
  const [formattedEndDate, setformattedEndDate] = useState(
    moment(defaultEndDate).format("YYYY-MM-DD"),
  );

  const [filtervalue, setFiltervalue] = useState("");
  const [TableLoading, setTableLoading] = useState(false);

  useEffect(() => {
    dispatch(
      getJobsCount({
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
      }),
    );
  }, []);

  const yourDynamicHeaderData = {
    _id: "Interveiw id",
    location: "Location",
    status: "Status",
    type: "Type",
    feedback: "Feedback",
  };

  const handleInterview = (Interview) => {
    // Do something with the selected candidate, e.g., fetch details
    setSelectedInterview(Interview);
    setOffcanvasOpen(true);
  };

  const handleJob = (job) => {
    // Do something with the selected candidate, e.g., fetch details
    dispatch(JobDetail(job?.jobdescription_guid)).then((response) => {
      if (response.payload.success === true) {
        setSelectedJob(response.payload.data?.jobdescription);
        setJobCanvasOpen(true);
      }
    });
  };

  const columns = [
    {
      Header: "Interview Id",
      accessor: "guid",
      Cell: ({ row }) => (
        <Link
          to={"#"}
          onClick={() => {
            handleInterview(row.original);
          }}
        >
          {row.original?.guid?.split("-")[0].toUpperCase()}-
          {row.original?.guid?.split("-")[1].toUpperCase()}
        </Link>
      ),
    },
    {
      Header: "Job Title",
      accessor: "title",
      Cell: ({ row }) => (
        <Link
          to={"#"}
          onClick={() => {
            handleJob(row.original);
          }}
        >
          {row.values.title}
        </Link>
      ),
    },

    {
      Header: "Type",
      accessor: "location",
      Cell: ({ value }) => <>{value ? value.toUpperCase() : "-"}</>,
    },
    // {
    //   Header: "Type",
    //   accessor: "type",
    //   Cell: ({ value }) => <>{value.toUpperCase()}</>,
    // },
    {
      Header: "Scheduled Date",
      accessor: "scheduled_at",
      Cell: (props) => {
        const tidyDate = dayjs(props.value).format("YYYY-MM-DD");
        return <span>{tidyDate}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",

      Cell: ({ row }) => (
        <div className="d-flex gap-1">
          {/* <p className="font-size-12 m-0"></p> */}
          <StatusBadge
            status={row.values.status}
            type={row.original.type.toUpperCase()}
          />
          {/* <Badge
            color={
              row.values.status === "selected"
                ? "success rounded-pill"
                : "warning rounded-pill"
            }
            className="font-size-11"
          >
            {row.original.type.toUpperCase()} {row.values.status}
          </Badge> */}
        </div>
      ),
    },

    // {
    //   Header: 'Discriptions',
    //   accessor: 'description',
    // },
    // Add more columns as needed
  ];

  const closeOffcanvas = () => {
    setOffcanvasOpen(false);
  };

  const closeJobCanvas = () => {
    setJobCanvasOpen(false);
  };

  useEffect(() => {
    // dispatch(getIndividualLocations())
    // dispatch(getIndividualJobRoles())
    const timer = setTimeout(() => {
      dispatch(
        getIndividualInterviews({
          filtervalue: filtervalue ? filtervalue : "",
        }),
      );
    }, 700);

    return () => clearTimeout(timer);
  }, [filtervalue]);

  useEffect(() => {
    if (individualStore.status === "idle") {
      if (individualStore.data.interviews?.success === true) {
        setTableLoading(false);
        setInterviewData(individualStore.data.interviews?.data?.interviews);
        setRecordCount(individualStore.data.interviews?.data?.totalCount);
      } else if (individualStore.data.interviews?.success === false) {
        setTableLoading(false);
      }
    }
    // if(individualStore.status === "idle") {
    //   if(individualStore.data.locations?.success === true) {
    //     setLocationOptions(individualStore.data.locations?.data?.enumlocations);
    //   }
    // }
    // if(individualStore.status === "idle") {
    //   if(individualStore.data.jobroles?.success === true) {
    //     setJobRoleOptions(individualStore.data.jobroles?.data?.enumjobroles);
    //   }
    // }
  }, [individualStore.data.interviews]);

  const handleValueChange = (newValue) => {
    setTableLoading(true);
    setFiltervalue(newValue);
  };

  // const jobroleOptions = JobRoleOptions.map((item) => ({
  //   value: item.code,
  //   label: item.title,
  // }));

  // const locationOptions = LocationOptions.map((item) => ({
  //   value: item.code,
  //   label: item.title,
  // }));

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Interviews"
            Name="Interviews"
          />
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-12">
                <CardBody>
                  <Row>
                    <div className="col-12 col-lg-6 col-md-6 d-sm-flex" />
                    <div className="col-12 col-lg-6 col-md-6">
                      <Col md={12}>
                        <CardTitle className="text-end fs-6 pt-3">
                          Total Interviews : {RecordCount}
                        </CardTitle>
                      </Col>
                    </div>
                  </Row>
                </CardBody>
                {/* <div>
                    <Card
                      style={{
                        backgroundColor: "#5156BE",
                        paddingTop: "15px",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <div className="col-12 col-lg-6 col-md-6 d-sm-flex">
                            <div className="col-12 col-lg-6">
                              <DropdownWithTwoField
                                // label="Option 1"
                                options={locationOptions}
                                placeholder="Select locations"
                              />
                            </div>{" "}
                            &nbsp;
                            <div className="col-12 col-lg-6">
                              <DropdownWithTwoField
                                options={jobroleOptions}
                                placeholder="Select Roles"
                              />
                            </div>
                          </div>
                          {/* <div className="col-12 col-lg-6 col-md-6">
                            <Col md={12}>
                              <CardTitle
                                style={{ paddingTop: "10px" }}
                                className="text-end text-white"
                              >
                                <strong> Search Result :</strong>
                              </CardTitle>
                            </Col>
                          </div> 
                        </Row>
                      </CardBody>
                    </Card>
                  </div> */}
                <div>
                  <Card>
                    <CardBody>
                      <CustomTable
                        tableDatas={InterviewData}
                        headerData={yourDynamicHeaderData}
                        columns={columns}
                        data={InterviewData}
                        hideCheckbox={true}
                        currentPage={0}
                        // ShowPagination={
                        //   InterviewData && InterviewData.length > 10
                        //     ? true
                        //     : false
                        // }
                        totalCount={RecordCount}
                        globalsearch={true}
                        onChange={handleValueChange}
                        isLoading={TableLoading}
                      />
                    </CardBody>
                  </Card>
                  {/* <DataTable title="All Jobs" columns={columns} data={jobs} /> */}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      {isOffcanvasOpen && (
        <CanvasInterview
          userType="individual"
          width={60}
          isOpen={isOffcanvasOpen}
          toggle={() => setOffcanvasOpen(!isOffcanvasOpen)}
          onClose={closeOffcanvas}
          data={selectedInterview}
        />
      )}

      {isJobCanvasOpen && (
        <JobOverview
          width={60}
          data={selectedJob}
          isOpen={isJobCanvasOpen}
          toggle={() => setJobCanvasOpen(!isJobCanvasOpen)}
          onClose={closeJobCanvas}
          showApply={false}
        />
      )}
    </React.Fragment>
  );
}

export default IndividualInterviews;
